.unreadDot {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background: var(--action-50);
  box-shadow: 0px 0px 5px 1px var(--focus-20);
}
